"// Normalizes role/status strings from various backends (Spring Boot, FastAPI, etc.)"
// Handles: uppercase enums (ADMIN), Spring Security prefix (ROLE_ADMIN), null/undefined, whitespace.
export const norm = (v) => (v || "").toString().trim().toLowerCase().replace(/^role_/, "");
